import React, { useEffect } from "react";
import utils from "../../../../../../utils";
import values from "../../../../../../values";
import Context from "../../../../../../context";

import * as Yup from "yup";

import { useFormik } from "formik";
import { ICreateAndUpdateSchool } from "../../../../../../types/school.interface";
import {
  IProvinceItem,
} from "../../../../../../types/common.interface";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomInput,
  CustomLeaflet,
  CustomView, LocationDropdowns,
} from "../../../../../../components";
import validations from "../../../../../../validations";
import Cookies from "js-cookie";
import constants from "../../../../../../values/constants";
import { useTranslation } from "react-i18next";
import {locationNamespace} from "../../../../../../types/location.namespace";

type Props = {
  defaultValues: ICreateAndUpdateSchool;
  onSubmit: (formData: ICreateAndUpdateSchool) => void;
};

const SchoolInformation: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const formVal = props.defaultValues;

  console.log(formVal);

  const { isLoading, setShowModal } = React.useContext(Context.SchoolScreen);
  const userType = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));

  const [location, setLocation] = React.useState<{ lat: string; long: string; }>();
  const [selectedGender, setSelectedGender] = React.useState<any>();
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({province: "", city: "", gender: ""});

  const { t } = useTranslation();

  const [selectedNeighborhood, setSelectedNeighborhood] = React.useState<locationNamespace.neighborhood.index | undefined>(formVal?.neighborhood || undefined);
  const [selectedProvince    , setSelectedProvince    ] = React.useState<locationNamespace.province    .index | undefined>(formVal?.province || undefined);
  const [selectedCity        , setSelectedCity        ] = React.useState<locationNamespace.city        .index | undefined>(formVal?.city || undefined);
  const [selectedArea        , setSelectedArea        ] = React.useState<locationNamespace.area        .index | undefined>(formVal?.area || undefined);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const formik = useFormik<ICreateAndUpdateSchool>({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: formVal?.phoneNumber ? formVal.phoneNumber : props?.defaultValues?.phoneNumber,
      telephone  : formVal?.telephone   ? formVal.telephone   : '',
      fullName   : formVal?.fullName    ? formVal.fullName    : '',
      address    : formVal?.address     ? formVal.address     : '',
      name       : formVal?.name        ? formVal.name        : '',
    },
    validationSchema: Yup.object({
      name       : validations.yupValidations.schoolName ,
      address    : validations.yupValidations.address    ,
      fullName   : validations.yupValidations.firstName  ,
      telephone  : validations.yupValidations.telephone  ,
      phoneNumber: validations.yupValidations.phoneNumber,
    }),
    onSubmit: (values: ICreateAndUpdateSchool, { setSubmitting }) => {
      if (!selectedProvince && !formVal?.province) return utils.errorHandler(9011);
      if (!selectedCity && !formVal?.city) return utils.errorHandler(9012);
      const formValues: ICreateAndUpdateSchool = {
        ...values,
        lat         : location?.lat  ? location.lat  : props.defaultValues?.lat ,
        long        : location?.long ? location.long : props.defaultValues?.long,
        city        : selectedCity,
        area        : selectedArea,
        gender      : selectedGender?.value,
        province    : selectedProvince,
        neighborhood: selectedNeighborhood,
      };
      if (
        (selectedCity     || formVal?.city    ) &&
        (selectedProvince || formVal?.province) &&
        selectedGender ) {
        Promise.resolve(props.onSubmit(formValues)).catch((e) => setSubmitting(false));
      }
    },
  });

  function submitHandler(): void {
    let dropDownErrorsList = {province: "", city: "", gender: "", location: "",};
    if (!location) {dropDownErrorsList = {...dropDownErrorsList, location: t("location_is_required"),};}
    if (!selectedProvince && !formVal?.province) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        province: t("province_is_required"),
        city: t("city_is_required"),
      };
    } else if (!selectedCity && !formVal?.city) {
      dropDownErrorsList = {...dropDownErrorsList, city: t("city_is_required"),};
    }
    setDropDownErrors(dropDownErrorsList);
    formik.submitForm();
  }

  function onSelectProvince(province: locationNamespace.province.index): void {
    setSelectedProvince(province);
    setDropDownErrors({
      ...dropDownErrors,
      neighborhood: undefined,
      province    : undefined,
      city        : undefined,
      area        : undefined,
    });
    setSelectedNeighborhood(undefined);
    setSelectedCity(undefined);
    setSelectedArea(undefined);
  }

  function onSelectCity(city: locationNamespace.city.index): void {
    setSelectedCity(city);
    setDropDownErrors({
      ...dropDownErrors,
      neighborhood: undefined,
      city        : undefined,
      area        : undefined,
    });
    setSelectedNeighborhood(undefined);
    setSelectedArea(undefined);
  }

  function onSelectArea(area: locationNamespace.area.index): void {
    setSelectedArea(area);
    setDropDownErrors({
      ...dropDownErrors,
      neighborhood: undefined,
      area        : undefined,
    });
    setSelectedNeighborhood(undefined);
  }

  function onSelectNeighborHood(neighborhood: locationNamespace.neighborhood.index): void {
    setSelectedNeighborhood(neighborhood);
    setDropDownErrors({
      ...dropDownErrors,
      neighborhood: undefined,
    });
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  useEffect(() => {
    setSelectedGender(values.dropdownItems.SCHOOL_GENDER.find((item) => item?.value === formVal?.gender));
    // setSelectedProvince(props.defaultValues)
  }, [props.defaultValues, formVal?.gender]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <CustomView.Container className="create-form-content">
      {(userType === "ADMIN" || userType === "COMPANY" || userType === "PROVINCE_EDUCATION") && (
        <>
          <CustomView.Row className="form-row">
            <CustomView.Column medium={6} className="form-colum dropdown">
              <LocationDropdowns.Province
                defaultItem  = { selectedProvince ? selectedProvince : formVal?.province }
                onSelectItem = { onSelectProvince }
                isError   = { dropDownErrors.province }
                errorText = { dropDownErrors.province }
              />
            </CustomView.Column>
            <CustomView.Column medium={6} className="form-colum dropdown">
              <LocationDropdowns.City
                defaultItem      = { selectedCity ? selectedCity : formVal?.city }
                onSelectItem     = { onSelectCity }
                selectedProvince = { selectedProvince ? selectedProvince : formVal?.province }
                isError   = { dropDownErrors.city }
                errorText = { dropDownErrors.city }
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column medium={6} className="form-colum dropdown">
              <LocationDropdowns.Area
                defaultItem={selectedArea ? selectedArea : formVal?.area}
                onSelectItem={onSelectArea}
                selectedCity={selectedCity ? selectedCity : formVal?.city}
                selectedProvince={selectedProvince ? selectedProvince : formVal?.province}
              />
            </CustomView.Column>
            <CustomView.Column medium={6} className="form-colum dropdown">
              <LocationDropdowns.Neighborhood
                defaultItem={selectedNeighborhood ? selectedNeighborhood : formVal?.neighborhood}
                onSelectItem={onSelectNeighborHood}
                selectedProvince={selectedProvince ? selectedProvince : formVal?.province}
                selectedCity={selectedCity ? selectedCity : formVal?.city}
                selectedArea={selectedArea ? selectedArea : formVal?.area}
              />
            </CustomView.Column>
          </CustomView.Row>
        </>
      )}
      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            id="name"
            name="name"
            label={t("schoolName")}
            value={formik.values.name}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.name && formik.touched.name}
            errorText={formik.errors.name}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum dropdown">
          <label className="form-label">{t("schoolGender")}</label>
          <CustomDropdownSearch
            items={values.dropdownItems.SCHOOL_GENDER}
            itemName="name"
            defaultItem={selectedGender}
            onSelectItem={(event: IProvinceItem) => {
              setSelectedGender(event);
              setDropDownErrors({ ...dropDownErrors, gender: "" });
            }}
            placeHolder={t("selectGender")}
          />
          <div className="error">{dropDownErrors.gender !== "" && dropDownErrors.gender}</div>
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            id="fullName"
            name="fullName"
            label={t("schoolManagerName")}
            value={formik.values.fullName}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.fullName && formik.touched.fullName}
            errorText={formik.errors.fullName}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            name="phoneNumber"
            id="phoneNumber"
            label={t("schoolManagerPhoneNumber")}
            value={formik.values.phoneNumber}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.phoneNumber && formik.touched.phoneNumber}
            errorText={formik.errors.phoneNumber}
            maxLength={11}
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            name="telephone"
            id="telephone"
            label={t("telephone")}
            value={formik.values.telephone}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.telephone && formik.touched.telephone}
            errorText={formik.errors.telephone}
            maxLength={11}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            name="address"
            id="address"
            label={t("address")}
            value={formik.values.address}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.address && formik.touched.address}
            errorText={formik.errors.address}
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="custom-leaflet-container">
        <CustomLeaflet
          defaultLat        = { location?.lat  ? location.lat  : props.defaultValues?.lat  }
          defaultLng        = { location?.long ? location.long : props.defaultValues?.long }
          defaultLatArea    = { selectedCity?.location ? selectedCity.location.coordinates[0] : props.defaultValues?.lat  }
          defaultLngArea    = { selectedCity?.location ? selectedCity.location.coordinates[1] : props.defaultValues?.long }
          onChangeLatAndLng = {(lat: any, long: any) => setLocation({ lat, long })}
        />
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column large={3} medium={4} small={6} className="form-colum">
          <div className="error">{dropDownErrors.location !== "" && dropDownErrors.location}</div>
          <CustomButton2 isLoading={isLoading} onClick={() => setShowModal("NONE")} title={t("cancel")} type="danger" />
        </CustomView.Column>
        <CustomView.Column large={3} medium={4} small={6} className="form-colum">
          <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t("next")}/>
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

}

export default SchoolInformation;
